/**
* Used to capitalize ONLY the first letter of a sentence
*/
export const capitalizeFirstLetter = (productName: string): string => {
    return productName.charAt(0).toUpperCase() + productName.slice(1)
}